import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const VerticalTemplateOneOneSeven = ({
  logoImage = "/yourLogo.svg",
  logoImagePreview = null,

  titleText = "THE BEST PRODUCT IS HERE",
  titleFont = "Helvetica",
  titleFontSize = "36",
  titleColor = "#FFFFFF",
  titleTextAlign = "center",
  titleIsBold = true,
  titleIsItalic = false,
  titleIsUnderline = false,

  subtitleText = "And it's yours today.",
  subtitleFont = "Helvetica",
  subtitleFontSize = "16",
  subtitleColor = "#FFFFFF",
  subtitleTextAlign = "center",
  subtitleIsBold = false,
  subtitleIsItalic = false,
  subtitleIsUnderline = false,

  contentImageOne = "/mug.png",
  contentImageOnePreview = null,

  backgroundType = "color",
  backgroundColor = "#2F4F4F",
  backgroundImage = null,

  buttonLabel = "Get started",
  buttonFont = "Helvetica",
  buttonIsBold = false,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "16",
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#6B8E23",

  backgroundImagePreview,

  preview = false,
  inmeeting = false,
  onClose,
  position = "left",
}) => {
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 767;

  return (
    <div
      className={`relative ${
        !inmeeting ? "h-full" : isMobile ? "h-full" : "!h-[89vh] mt-[30%] w-72"
      } ${
        isMobile && inmeeting
          ? position === "left" || position === "right"
            ? "" // Let it size naturally
            : "w-full" // Fill container for center/top/bottom
          : "w-72"
      } flex flex-col mx-auto justify-between items-center p-4 md:p-8 overflow-hidden`}
      style={{ backgroundColor }}
    >
      {/* Close Button */}
      {inmeeting && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Background Image */}
      {(backgroundImage || backgroundImagePreview) && (
        <div
          className="absolute inset-0 w-full h-full opacity-90"
          style={{
            backgroundImage: `url(${
              backgroundImage instanceof File
                ? backgroundImagePreview
                : backgroundImage
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}

      {/* Content Container */}
      <div className="relative h-full z-10 flex flex-col justify-center items-center w-full max-w-4xl mx-auto gap-4 md:gap-6">
        {/* Logo */}
        {(logoImage || logoImagePreview) && (
          <div className="mb-2">
            <img
              src={
                logoImage instanceof File
                  ? logoImagePreview
                  : logoImage || "/yourLogo.svg"
              }
              alt="logo"
              className="w-16 h-16 md:w-20 md:h-20 object-contain"
            />
          </div>
        )}

        {/* Main Heading */}
        <h1
          className={`text-center uppercase ${
            explicitBoleanCheck(titleIsBold) ? "font-bold" : ""
          } ${explicitBoleanCheck(titleIsItalic) ? "italic" : ""} ${
            explicitBoleanCheck(titleIsUnderline) ? "underline" : ""
          }`}
          style={{
            color: titleColor,
            fontSize: `${titleFontSize}px`,
            fontFamily: titleFont,
            textAlign: titleTextAlign,
            lineHeight: "1.1",
            whiteSpace: "pre-line",
            marginBottom: "20px",
          }}
        >
          {titleText}
        </h1>

        {/* Product Image */}
        {(contentImageOne || contentImageOnePreview) && (
          <div className="w-full max-w-xs mb-4">
            <img
              src={
                contentImageOne instanceof File
                  ? contentImageOnePreview
                  : contentImageOne
              }
              alt="product"
              className="w-full h-auto object-contain rounded"
            />
          </div>
        )}

        {/* Subtitle */}
        <div
          className={`text-center ${
            explicitBoleanCheck(subtitleIsBold) ? "font-bold" : ""
          } ${explicitBoleanCheck(subtitleIsItalic) ? "italic" : ""} ${
            explicitBoleanCheck(subtitleIsUnderline) ? "underline" : ""
          }`}
          style={{
            color: subtitleColor,
            fontSize: `${subtitleFontSize}px`,
            fontFamily: subtitleFont,
            textAlign: subtitleTextAlign,
            whiteSpace: "pre-line",
            marginBottom: "20px",
          }}
        >
          {subtitleText}
        </div>

        {/* Button */}
        <button
          className={`px-8 py-3 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl ${
            buttonLink ? "cursor-pointer" : "cursor-default"
          }`}
          style={{
            backgroundColor: buttonBackgroundColor,
            color: buttonFontColor,
            fontSize: `${buttonFontSize}px`,
            fontFamily: buttonFont,
            fontWeight: explicitBoleanCheck(buttonIsBold) ? "bold" : "normal",
            fontStyle: explicitBoleanCheck(buttonIsItalic)
              ? "italic"
              : "normal",
            textDecoration: explicitBoleanCheck(buttonIsUnderline)
              ? "underline"
              : "none",
          }}
          onClick={() => {
            if (buttonLink) {
              window.open(buttonLink, "_blank");
            }
          }}
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
};

export default VerticalTemplateOneOneSeven;

